export const APP_VERSION = 19;

export const PERMISSIONS = [
  { domain: "Patient Management" },
  { domain: "Bill Management" },
  { domain: "Doctor Management" },
  { domain: "Service Management" },
];

export const INITIAL_INVESTIGATION = [
  {
    name: "",
    minRange: "",
    maxRange: "",
    method: "",
    subInvestigations: [],
  },
];

export const INDIAN_STATES = [
  { code: "01", name: "Jammu and Kashmir" },
  { code: "02", name: "Himachal Pradesh" },
  { code: "03", name: "Punjab" },
  { code: "04", name: "Chandigarh" },
  { code: "05", name: "Uttarakhand" },
  { code: "06", name: "Haryana" },
  { code: "07", name: "Delhi" },
  { code: "08", name: "Rajasthan" },
  { code: "09", name: "Uttar Pradesh" },
  { code: "10", name: "Bihar" },
  { code: "11", name: "Sikkim" },
  { code: "12", name: "Arunachal Pradesh" },
  { code: "13", name: "Nagaland" },
  { code: "14", name: "Manipur" },
  { code: "15", name: "Mizoram" },
  { code: "16", name: "Tripura" },
  { code: "17", name: "Meghalaya" },
  { code: "18", name: "Assam" },
  { code: "19", name: "West Bengal" },
  { code: "20", name: "Jharkhand" },
  { code: "21", name: "Odisha" },
  { code: "22", name: "Chhattisgarh" },
  { code: "23", name: "Madhya Pradesh" },
  { code: "24", name: "Gujarat" },
  { code: "26", name: "Dadra and Nagar Haveli and Daman and Diu" },
  { code: "27", name: "Maharashtra" },
  { code: "28", name: "Andhra Pradesh" },
  { code: "29", name: "Karnataka" },
  { code: "30", name: "Goa" },
  { code: "31", name: "Lakshadweep" },
  { code: "32", name: "Kerala" },
  { code: "33", name: "Tamil Nadu" },
  { code: "34", name: "Puducherry" },
  { code: "35", name: "Andaman and Nicobar Islands" },
  { code: "36", name: "Telangana" },
  { code: "38", name: "Ladakh" },
  { code: "97", name: "Other State" },
];

export const MEDICAL_DEPTS = [
  "Biochemistry",
  "Microbiology",
  "Radiology",
  "Immunology",
  "Cytopathology",
  "Histopathology",
  "Surgical Pathology",
  "Clinical Microbiology",
  "Blood Banking",
  "Reproductive Biology",
  "Molecular Diagnostics",
  "Cytogenetics",
  "Diagnostic Imaging",
  "Physical & Visual Examination",
  "ECG",
  "Endoscopy",
  "Holter Monitor",
  "Serology",
  "Echocardiography",
  "Colonoscopy",
  "Clinical Pathology",
  "Haematology",
  "Ultrasound",
  "X-Ray",
  "CT-Scan",
];

export const REPORT_TYPE = ["Normal", "Widal"];
export const WIDAL_COLUMNS = ["1:20", "1:40", "1:80", "1:160", "1:320"];

export const BASE_URL_LOCAL = "http://localhost:8000/";
export const BASE_URL_RENDER = "https://api.elitss.in/";
export const BASE_URL_HOSTINGER = "https://api.elitss-pulse.in/"; //

const hostname = window.location.hostname;

export const BASE_URL =
  hostname === "elitss.in" || hostname === "www.elitss.in"
    ? BASE_URL_RENDER
    : hostname === "elitss-pulse.in" || hostname === "www.elitss-pulse.in"
      ? BASE_URL_HOSTINGER
      : BASE_URL_LOCAL; //s

export const ACTIONS = {
  regPatient: "REG_PATIENT",
  deletePatient: "DELETE_PATIENT",
  editPatient: "EDIT_PATIENT",

  regDoctor: "REG_DOCTOR",
  deleteDoctor: "DELETE_DOCTOR",
  editDoctor: "EDIT_DOCTOR",

  createCenter: "CREATE_CENTER",

  createAppointment: "CREATE_APPOINTMENT",
  deleteAppointment: "DELETE_APPOINTMENT",

  createTestHeader: "CREATE_TEST_HEADER",
  updateTestHeader: "UPDATE_TEST_HEADER",

  createPathologyInvestigation: "CREATE_PATHOLOGY_INVESTIGATION",
  updatePathologyInvestigation: "UPDATE_PATHOLOGY_INVESTIGATION",

  createRadiologyInvestigation: "CREATE_RADIOLOGY_INVESTIGATION",
  updateRadiologyInvestigation: "UPDATE_RADIOLOGY_INVESTIGATION",

  createInvoice: "CREATE_INVOICE",
  deleteInvoice: "DELETE_INVOICE",
  updateInvoice: "UPDATE_INVOICE",
  editInvoice: "EDIT_INVOICE",

  insertPaidInvoiceAmount: "INSERT_PAID_INVOICE_AMOUNT",

  createPathologyReport: "CREATE_PATHOLOGY_REPORT",
  updatePathologyReport: "UPDATE_PATHOLOGY_REPORT",
  uploadPathologyReport: "UPLOAD_PATHOLOGY_REPORT",
  resendActionOnPathologyReport: "RESEND_ACTION_ON_PATHOLOGY_REPORT",
  approvedActionOnPathologyReport: "APPROVED_ACTION_ON_PATHOLOGY_REPORT",
  resendActionOnPathologyReport: "RESEND_ACTION_ON_PATHOLOGY_REPORT",

  createRadiologyReport: "CREATE_RADIOLOGY_REPORT",

  printInvoice: "PRINT_INVOICE",
  printAdvice: "PRINT_ADVISE",
  printPathologyReport: "PRINT_PATHOLOGY_REPORT",
  printRadiologyReport: "PRINT_RADIOLOGY_REPORT",
};

export const TARGET_TYPE = {
  patient: "Patient",
  doctor: "Doctor",
  center: "Center",
  appointment: "Appointment",
  testHeader: "Test Header",
  pathologyInvestigation: "Pathology Investigation",
  radiologyInvestigation: "Radiology Investigation",
  invoice: "Invoice",
  pathologyReport: "pathologyReport",
  radiologyReport: "radiologyReport",
};

export const PIE_COLORS = [
  "#FF6F61", // Bright Coral
  "#FFB400", // Vivid Amber
  "#4CAF50", // Bright Green
  "#2196F3", // Bright Blue
  "#E91E63", // Vibrant Pink
  "#9C27B0", // Deep Purple
  "#FF9800", // Bright Orange
  "#03A9F4", // Sky Blue
  "#8BC34A", // Light Lime
  "#F44336", // Bright Red
];

export const PIE_BG_COLORS = ["#FFF4E6", "#E6F4F1", "#EDE7F6", "#F3F9E6"];

// autoplay={{
//   delay: 3000, // 3 seconds per slide
//   disableOnInteraction: false,
//   pauseOnMouseEnter: true,
// }}

export const SYMBOLS = [
  "≥",
  "≤",
  "≠",
  "≈",
  "=",
  ">",
  "<",
  "+",
  "-",
  "±",
  "×",
  "°",
  "Ω",
  "ω",
  "α",
  "β",
  "γ",
  "δ",
  "θ",
  "∞",
  "∑",
  "√",
  "%",
  "/",
  "*",
  "#",
  "@",
  "&",
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
  ":",
  ";",
  ",",
  ".",
  "!",
];
